<template>
  <!-- 费用设置 -->
  <div class="main-container page-container">
    <Tabs v-model="tab">
      <TabPane label="产品配置" name="productConfig"></TabPane>
      <TabPane label="费用配置" name="commissionRateConfig"></TabPane>
    </Tabs>
    <!-- 产品配置 -->
    <productConfig v-if="tab == 'productConfig'"></productConfig>
    <!-- 费用配置 -->
    <commissionRelatedConfig v-if="tab == 'commissionRateConfig'"></commissionRelatedConfig>
  </div>
</template>

<script>
import commissionRelatedConfig from './commissionRelatedConfig';
import productConfig from './productConfig';
export default {
  components: {
    productConfig,
    commissionRelatedConfig,
  },
  data() {
    return {
      tab: 'productConfig'
    };
  },

  created() {
    this.tab = this.$route.query.tab || 'productConfig';
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
